import { ReactNode, useEffect } from "react";
import LoadingScreen from "src/components/LoadingScreen";
import AuthContext from "src/contexts/auth/authContext";
import useAuthStore from "src/contexts/auth/store";
import useAxiosInterceptorsSetup from "src/services/config/useAxiosInterceptorsSetup";

import useInitAuth from "./useInitAuth";

// ----------------------------------------------------------------------

type Props = {
	children: ReactNode;
};

export default function AuthProvider({ children }: Props) {
	const [state, actions] = useAuthStore();
	const { signIn, signOut, init } = actions;

	useAxiosInterceptorsSetup({ signIn, signOut });

	const { initializeAuth } = useInitAuth({
		init,
		signIn,
		signOut
	});

	useEffect(() => {
		initializeAuth();
	}, []);

	if (!state.isInitialized) {
		return <LoadingScreen />;
	}

	return <AuthContext.Provider value={{ actions, state }}>{children}</AuthContext.Provider>;
}
